import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { HeadlineTextSmall } from 'Packages/FacetDesign/Components/Text';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer } from '@facet-wealth/design';
import { MFAAlert } from 'Components/ComponentLibrary/Molecules/MFAAlert/MFAAlert';
import { getTemplate } from './Templates';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', { _component: () => HeadlineTextSmall }, overrideReadOnly)
  .nameOverride('alert', {
    _component: () => MFAAlert,
  }, overrideReadOnly);

export const Content = () => {
  const {
    collection,
    setCollection,
  } = useCollectionStateContext();
  const resource = collection.resources().head();

  const Layout = getTemplate(resource);

  return (
    <WorkflowLayout appearance={'elevated'} alwaysShowFacetLogo>
      <FDContentContainer maxWidth={'sm'}>
        <MetaResourceRenderer
          layout={Layout}
          resource={resource}
          metaOverrideSet={metaOverrideSet}
          onSubmit={(resp) => setCollection(resp)}
        />
      </FDContentContainer>
    </WorkflowLayout>
  );
};
